export const perfNow = (): number =>
  window.performance && window.performance.now ? window.performance.now() : Date.now();
